/**
 * @flow
 * @relayHash 5d0a626de1cafd86d303da70521c85fe
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type testInviteEmailInput = {|
  clientMutationId?: ?string,
  id: string,
  recipients: string,
  subject: string,
  bodyHtml: string,
  bodyPlain?: ?string,
  from?: ?string,
  cc?: ?string,
  bcc?: ?string,
  reply_to?: ?string,
  attachments?: ?string,
  preheader?: ?string,
  prefix?: ?string,
  comment?: ?string,
|};
export type testInviteMutationVariables = {|
  input: testInviteEmailInput
|};
export type testInviteMutationResponse = {|
  +testInviteEmail: ?{|
    +hyevent: ?{|
      +id: string,
      +campaignTested: ?boolean,
    |}
  |}
|};
export type testInviteMutation = {|
  variables: testInviteMutationVariables,
  response: testInviteMutationResponse,
|};
*/


/*
mutation testInviteMutation(
  $input: testInviteEmailInput!
) {
  testInviteEmail(input: $input) {
    hyevent {
      id
      campaignTested
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "testInviteEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "testInviteEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "testInviteEmailPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "campaignTested",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "testInviteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "testInviteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "testInviteMutation",
    "id": null,
    "text": "mutation testInviteMutation(\n  $input: testInviteEmailInput!\n) {\n  testInviteEmail(input: $input) {\n    hyevent {\n      id\n      campaignTested\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '218b630c3eb0d4f71c0aaa87efca4134';
module.exports = node;
